import { Stack, Typography } from "@mui/material";
import FeatureDetail from "./FeatureDetail";
import { FeatureGroup as FeatureGroupType } from "@/types/plans";

const FeatureGroup = ({ title, features }: FeatureGroupType) => (
  <Stack spacing={1.2} sx={{ backgroundColor: "white" }} px={3} py={2}>
    <Typography variant="subtitle2" fontWeight={600}>
      {title}
    </Typography>

    {features.map((feature, i) => (
      <FeatureDetail key={i} {...feature} />
    ))}
  </Stack>
);

export default FeatureGroup;
